import {atom} from "recoil";

export const LocalData = atom({
    key:"LocalData",
    default:"true",
})